/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Adminsubs_Ledgergrant2Inputs */

const zh_adminsubs_ledgergrant2 = /** @type {(inputs: Adminsubs_Ledgergrant2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`充值`)
};

const en_adminsubs_ledgergrant2 = /** @type {(inputs: Adminsubs_Ledgergrant2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Grant`)
};

const es_adminsubs_ledgergrant2 = /** @type {(inputs: Adminsubs_Ledgergrant2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recarga`)
};

/**
* | output |
* | --- |
* | "Grant" |
*
* @param {Adminsubs_Ledgergrant2Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const adminsubs_ledgergrant2 = /** @type {((inputs?: Adminsubs_Ledgergrant2Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Adminsubs_Ledgergrant2Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_adminsubs_ledgergrant2(inputs)
	if (locale === "en") return en_adminsubs_ledgergrant2(inputs)
	return es_adminsubs_ledgergrant2(inputs)
});
export { adminsubs_ledgergrant2 as "adminSubs_ledgerGrant" }